import { apiEndPoints } from "utils/api-endpoints";
import HTTPService from "utils/httpService";

export const getOverviewListAPI = (params?: string) => {
  return HTTPService.get(`${apiEndPoints.universeAPI.peerNode.overview.list}/${params}`);
};
